import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'breakText',
    standalone: false
})
export class BreakTextsPipe implements PipeTransform {

  transform(str: string): string {
    return str.replace(/['"]+/g, '').replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/<br><br>/, '<br>');
  }

}
